import { startupsUrl } from '@src/lib/startups-url'
import { usePathname, useSearchParams } from 'next/navigation'

export const useLoginHref = () => {
  const pathname = usePathname()
  const params = useSearchParams()

  const paramsObj = {}
  params.forEach((value, key) => (paramsObj[key] = value))
  paramsObj['prompt'] = 'login'

  return startupsUrl(pathname, paramsObj)
}
